import * as actionTypes from './actionTypes';
import * as actions from './index';

const deleteMediaFileStart = () => {
    return {
        type: actionTypes.DELETE_MEDIAFILE_START
    };
};

const deleteMediaFileSuccess = () => {
    return {
        type: actionTypes.DELETE_MEDIAFILE_SUCCESS
    };
};

const deleteMediaFileFail = (error) => {
    return {
        type: actionTypes.DELETE_MEDIAFILE_FAIL,
        error: error
    };
};

export const deleteMediaFile = (id, clipId) => {
    return dispatch => {
        dispatch(deleteMediaFileStart());

        window.flow.delMediafile(id).then(res => {
            dispatch(deleteMediaFileSuccess());
            dispatch(actions.getClipById(clipId));
        }).catch(res => {
            dispatch(deleteMediaFileFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const editMediaFile = (id, params, clipId) => {
    return dispatch => {
        dispatch({ type: actionTypes.EDIT_MEDIAFILE_START });
        window.flow.editMediafile(id, params).then(res => {
            console.log(res);
            dispatch(actions.getClipById(clipId));
            dispatch({ type: actionTypes.EDIT_MEDIAFILE_SUCCESS });
        }).catch(res => {
            dispatch({ type: actionTypes.EDIT_MEDIAFILE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const setThumbnail = (id, clipId) => {
    return dispatch => {
        dispatch({ type: actionTypes.MEDIAFILE_SET_THUMB_START });
        window.flow.editMediafile(id, { mode: 'replacethumb' }).then(res => {
            console.log(res);
            dispatch(actions.getClipById(clipId));
            dispatch({ type: actionTypes.MEDIAFILE_SET_THUMB_SUCCESS });
        }).catch(res => {
            dispatch({ type: actionTypes.MEDIAFILE_SET_THUMB_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};
